import * as React from 'react';
import {
  DateTimeInput,
  Edit,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  useRecordContext,
} from 'react-admin';
import postStatusChoices from '../../../choices/post/post-status.choices';
import CustomRichTextInput from '../../components/common/CustomRichTextInput';
import S3ImageInput from '../../components/common/S3ImageInput';
import TagsReferenceArrayInput from '../../components/post/TagsReferenceArrayInput';

const ArticleTitle = () => {
  const record = useRecordContext<ArticleType>();
  return <span>{record ? record.title : ''}</span>;
};

const ArticleEdit = () => (
  <Edit title={<ArticleTitle />}>
    <SimpleForm>
      <TextInput disabled source="id" label="resource.common.field.id" />
      <DateTimeInput
        source="date"
        label="resource.global.field.date"
        defaultValue={new Date()}
        isRequired
        validate={required()}
      />
      <TextInput
        source="title"
        label="resource.global.field.title"
        isRequired
        validate={required()}
      />
      <SelectInput
        source="status"
        label="resource.posts.field.status.name"
        choices={postStatusChoices}
        isRequired
        validate={required()}
      />
      <TagsReferenceArrayInput />
      <S3ImageInput
        source="thumbnail"
        label="resource.global.field.thumbnail"
      />
      <CustomRichTextInput
        source="content"
        label="resource.articles.field.content"
        withImage
      />
    </SimpleForm>
  </Edit>
);

export default ArticleEdit;
